import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: flex-start;
  gap: 5px;
`;
